import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface FontSizeSelectProps {
  value?: string;
  onChange: (size: string) => void;
  disabled?: boolean;
}

const sizes = [
  { value: '8px', label: '8' },
  { value: '10px', label: '10' },
  { value: '12px', label: '12' },
  { value: '14px', label: '14' },
  { value: '16px', label: '16' },
  { value: '18px', label: '18' },
  { value: '20px', label: '20' },
  { value: '24px', label: '24' },
  { value: '28px', label: '28' },
  { value: '36px', label: '36' },
  { value: '48px', label: '48' },
];

const FontSizeSelect: React.FC<FontSizeSelectProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-[70px] h-8 text-xs">
        <SelectValue placeholder="Size" />
      </SelectTrigger>
      <SelectContent>
        {sizes.map((size) => (
          <SelectItem key={size.value} value={size.value}>
            {size.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FontSizeSelect;
